import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class S3Service {

  constructor(private http: HttpClient) {}

  /**
   * Sube un archivo a una URL (presigned URL de S3)
   * @param file Archivo a subir
   * @param url URL pre-firmada
   */
  uploadFile(file: File, url: string): Observable<any> {
    return this.http.put(url, file, {
      headers: {
        'Content-Type': file.type || 'application/zip'
      },
      reportProgress: true,
      observe: 'events'
    });
  }

  /**
   * Descarga un archivo desde una URL de S3
   * @param url URL del archivo en S3
   */
  downloadFile(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }
}
